var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99989 7.12101C5.86856 7.12116 5.73848 7.09535 5.61715 7.04507C5.49582 6.99479 5.38562 6.92102 5.29289 6.82801L1.05018 2.58586C0.862668 2.39834 0.757323 2.14402 0.757324 1.87883C0.757325 1.61364 0.862672 1.35931 1.05019 1.1718C1.23771 0.98428 1.49203 0.878935 1.75722 0.878936C2.02241 0.878937 2.27674 0.984283 2.46425 1.1718L5.99989 4.70692L9.53553 1.17177C9.72305 0.984254 9.97738 0.878907 10.2426 0.878906C10.5078 0.878905 10.7621 0.98425 10.9496 1.17177C11.1371 1.35928 11.2425 1.61361 11.2425 1.8788C11.2425 2.14399 11.1371 2.39831 10.9496 2.58583L6.70689 6.82804C6.61416 6.92105 6.50396 6.99481 6.38263 7.04508C6.2613 7.09536 6.13123 7.12117 5.99989 7.12101V7.12101Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default __webpack_public_path__ + "static/media/icon-chevron-down.cadabb8b.svg";
export { ForwardRef as ReactComponent };